// extracted by mini-css-extract-plugin
module.exports = {"radio":"Input__radio__3s6bR","radio2":"Input__radio2__2xAI_","imgCheck":"Input__imgCheck__2CAbz","textoCheck":"Input__textoCheck__1SvY3","checkCuadro":"Input__checkCuadro__zPPnH"};